// Inline SVG donut, deliberately a copy of the pattern in PresentationScreen
// rather than an extraction from it: editing the presented sheet during demo
// week would put a working client-facing view at risk for no functional gain.
// Consolidate the two once the assessment has settled.

export default function Donut({ segments, centerLabel, centerValue, size = 132 }) {
  const total = segments.reduce((s, x) => s + x.value, 0) || 1;
  let offset = 0;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
      <div style={{ position: 'relative', width: size, height: size, flex: 'none' }}>
        <svg viewBox="0 0 100 100" style={{ width: size, height: size, display: 'block' }}>
          <circle cx="50" cy="50" r="42" fill="none" stroke="#e4e7ec" strokeWidth="13" />
          {segments.map((s, i) => {
            const len = (s.value / total) * 100;
            const el = (
              <circle
                key={i}
                cx="50" cy="50" r="42" fill="none"
                stroke={s.color} strokeWidth="13" pathLength="100"
                strokeDasharray={`${len} ${100 - len}`}
                strokeDashoffset={-offset}
                transform="rotate(-90 50 50)"
              />
            );
            offset += len;
            return el;
          })}
        </svg>
        {(centerLabel || centerValue) && (
          <div style={{
            position: 'absolute', inset: 0, display: 'flex',
            flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            pointerEvents: 'none',
          }}>
            {centerValue && (
              <div style={{ font: '600 15px var(--font-display)', color: 'var(--navy)' }}>
                {centerValue}
              </div>
            )}
            {centerLabel && (
              <div style={{ font: '500 10px var(--font-body)', color: 'var(--ink-4)', letterSpacing: '.04em', textTransform: 'uppercase' }}>
                {centerLabel}
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 9 }}>
        {segments.map((s, i) => (
          <div key={i} style={{ font: '500 13px var(--font-body)', color: 'var(--ink-3)' }}>
            <span className="asmt-legend-key" style={{ background: s.color }} />
            {s.label} · {Math.round((s.value / total) * 100)}%
          </div>
        ))}
      </div>
    </div>
  );
}
